import api from './api';

export default async function getAllTemplates() {
  const { data } = await api.get(`arc-automarker/templates`);

  return data;
}